import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'
import { isPersistentValue } from '../ListItem.utils'

import * as styles from './TextListItemContent.module.css'

function TextListItemContent({
  additionalInfo,
  className = styles.TextListItemContent,
  disabled,
  isActive,
  isFocused,
  isHovered,
  isPersistent,
  link,
  showTooltip,
  text,
  textClassName: textClassNameProp,
  tooltipContent,
  value,
}) {
  const { t } = useTranslation()

  const preparedText =
    text && (link || isPersistentValue(value, isPersistent)) ? t(text) : text

  const {
    overflow: isTextOverflow,
    setContentOverflowRef: setTextOverflowRef,
  } = useContentOverflow({ dep: [preparedText] })

  const {
    overflow: isAdditionalInfoOverflow,
    setContentOverflowRef: setAdditionalInfoOverflowRef,
  } = useContentOverflow({ dep: [additionalInfo] })

  const tooltip = disabled && tooltipContent ? tooltipContent : preparedText

  const mods = {
    [styles.disabled]: disabled,
    [styles.hover]: isActive || isFocused || isHovered,
  }

  const textClassName = classNames(styles.text, mods, textClassNameProp)
  const additionalInfoClassName = classNames(styles.additionalInfoText, mods)

  return (
    <div className={className}>
      <FloatingTooltip
        content={tooltip}
        disabled={(!showTooltip || !isTextOverflow) && !tooltipContent}
      >
        <Text className={textClassName} ref={setTextOverflowRef}>
          {preparedText}
        </Text>
      </FloatingTooltip>
      {additionalInfo ? (
        <FloatingTooltip
          content={additionalInfo}
          disabled={!showTooltip || !isAdditionalInfoOverflow}
        >
          <Text
            isSecondary
            className={additionalInfoClassName}
            ref={setAdditionalInfoOverflowRef}
          >
            {additionalInfo}
          </Text>
        </FloatingTooltip>
      ) : null}
    </div>
  )
}

export default TextListItemContent
